var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tepmplate-block',{attrs:{"mod-class":"","content-class":"overflow-auto main-wrap pt-4","title-page":"Создание новости"}},[_c('news-form',{on:{"save":_vm.save}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }